import { render, staticRenderFns } from "./UserProfileSidebar.vue?vue&type=template&id=2b013c33&scoped=true&"
import script from "./UserProfileSidebar.vue?vue&type=script&lang=js&"
export * from "./UserProfileSidebar.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileSidebar.vue?vue&type=style&index=0&id=2b013c33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b013c33",
  null
  
)

export default component.exports